module.exports = __webpack_public_path__ + "img/bb_g1_t_eyes-06.e9fdc12d.svg";